"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAnchorLinkSmoothScroll = _interopRequireDefault(require("react-anchor-link-smooth-scroll"));

require("./AnchorSmooth.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Stateless component to draw a AnchorSmooth.
 * @param {JSX} children Children to be rendered.
 * @param {string} text Text of the anchor.
 * @param {string} alt Alternative text of the anchor.
 * @param {string} idToScroll id to scroll when user click the anchor
 * @param {number} offset Offset used if the sticky bar is floating
 * @returns {JSX} Component JSX.
 */
var AnchorSmooth = function AnchorSmooth(_ref) {
  var text = _ref.text,
      alt = _ref.alt,
      idToScroll = _ref.idToScroll,
      offset = _ref.offset;
  return _react.default.createElement(_reactAnchorLinkSmoothScroll.default, {
    className: "anchorSmooth",
    href: "#".concat(idToScroll),
    alt: alt,
    offset: offset
  }, text);
};
/*  Proptypes for the Card props */


AnchorSmooth.propTypes = {
  text: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string.isRequired,
  idToScroll: _propTypes.default.string.isRequired,
  offset: _propTypes.default.number
};
/* Default values for non required props */

AnchorSmooth.defaultProps = {
  offset: 0
};
var _default = AnchorSmooth;
exports.default = _default;

//# sourceMappingURL=index.js.map